module.exports = __webpack_public_path__ + "img/mobile.7eb23cd7.png";